import dayjs from "dayjs";
import i18n, { t } from "i18next";
import { Amount } from "@/models/amount";
import { InternalInvoiceItem } from "@/models/internal-invoice";
import { apiDateTimeFormat } from "@/utils";

const HEADERS = [
  "Payee Code",
  "Account Name",
  "Remittance Number",
  "Invoice Number",
  "Invoice Date",
  "Payment Due Date",
  "Fee",
  "Recovered Amount",
  "Amount",
];

function formatDate(value?: string): string {
  return value ? dayjs(value, apiDateTimeFormat).format(t("dateFormat")) : "-";
}

function formatCurrency(amount?: Amount): string {
  if (!amount || amount.value === undefined || amount.value === null || amount.currency.symbol === "") {
    return "-";
  }
  return (
    amount.value.toLocaleString(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
    " " +
    amount.currency.symbol
  );
}

function formatPercentage(value?: number): string {
  return value !== undefined && value !== null
    ? value.toLocaleString(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %"
    : "-";
}

function escapeCsvField(value: string): string {
  if (value.includes(",") || value.includes('"') || value.includes("\n") || value.includes("\r")) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function itemToRow(item: InternalInvoiceItem): string[] {
  return [
    item.payeeCode,
    item.accountName,
    item.remittanceNumber,
    item.invoiceNumber,
    formatDate(item.invoiceDate),
    formatDate(item.paymentDueDate),
    formatPercentage(item.fee),
    formatCurrency(item.recoveredAmount),
    formatCurrency(item.amount),
  ];
}

export function exportInternalInvoiceItemsCsv(items: InternalInvoiceItem[], filename: string) {
  const lines = [
    HEADERS.map(escapeCsvField).join(","),
    ...items.map((item) => itemToRow(item).map(escapeCsvField).join(",")),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
